<template>
    <Dialog header="Continue Your Session" :visible="true" :modal="true">
        <div>Your project will be release to other people when your session is expired.</div>
        <div class="count-down">{{ countDown }}</div>
        <template #footer>
            <Button label="Extend Session" @click="extendSession" autofocus />
        </template>
    </Dialog>
</template>

<script>

export default {
    name: 'SessionPopup',
    props: {
        countDown: String
    },
    data() {

        return {
            // below Alex
            isLoading: false,
            fullPage: true,
            canCancel: true,
            useSlot: false,
            loader: 'bars',
            color: '#00632C',
            bgColor: '#ffffff',
            height: 128,
            width: 128,
            //above Alex
            opening: "pi pi-folder-open",
            showProject: true,
            showComponents: false,
            reject: false,
            dialogContent: "",
            dialogButton: "",
            dialogTarget: "",
            dialogDisplay: false,

            mitigationMessage: "",
            mitigationPage: 1
        }
    },
    computed: {
    },

    methods: {
        extendSession() {
            this.$emit('extendSession');
        }
    }
}
</script>

<style lang="less" scoped>
.count-down {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin: 10px;
}
</style>
